// extracted by mini-css-extract-plugin
export default {"SwipeLeftToClose":"bex_a bhs_bk bhs_bl bhs_bo","SwipeLeftToClose--animating":"bex_b"};